import React, { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import styles from './Account.module.scss'
import { AccountMenu } from './components/AccountMenu'
import { AccountForm } from './components/AccountForm'
import { ChangePasswordForm } from './components/ChangePasswordForm'
import { ConnectedEmailNotificationsForm } from './components/EmailNotificationsForm'
import { ConnectedLanguageForm } from './components/LanguageForm/LanguageForm'

export const Account: FC = () => {
  return (
    <div className={styles.account}>
      <AccountMenu />
      <div className={styles.content}>
        <Routes>
          <Route path={'/'} element={<AccountForm />} />
          <Route path={'/reset-password'} element={<ChangePasswordForm />} />
          <Route path={'/notifications'} element={<ConnectedEmailNotificationsForm />} />
          <Route path={'/language'} element={<ConnectedLanguageForm />} />
        </Routes>
      </div>
    </div>
  )
}

Account.displayName = 'Account'
